export const FETCH_LOGIN_OPTIONS = "FETCH_LOGIN_OPTIONS";
export const FETCH_LOGIN_OPTIONS_SUCCESS = "FETCH_LOGIN_OPTIONS_SUCCESS";
export const FETCH_LOGIN_OPTIONS_ERROR = "FETCH_LOGIN_OPTIONS_ERROR";
export const CREATE_LOGIN_OPTIONS = "CREATE_LOGIN_OPTIONS";
export const CREATE_LOGIN_OPTIONS_SUCCESS = "CREATE_LOGIN_OPTIONS_SUCCESS";
export const CREATE_LOGIN_OPTIONS_ERROR = "CREATE_LOGIN_OPTIONS_ERROR";
